export const ISSUE_TYPES = ["epic", "story", "task", "subtask", "bug"] as const;
export type IssueType = (typeof ISSUE_TYPES)[number];

export const PRIORITY_LEVELS = ["highest", "high", "medium", "low", "lowest"] as const;
export type PriorityLevel = (typeof PRIORITY_LEVELS)[number];

const TYPE_META: Record<IssueType, { bg: string; icon: string; label: string }> = {
  epic: { bg: "#8f5fe8", icon: "bi-lightning-charge-fill", label: "Epic" },
  story: { bg: "#2f8132", icon: "bi-bookmark-fill", label: "Story" },
  task: { bg: "#1868db", icon: "bi-check2-square", label: "Task" },
  subtask: { bg: "#1868db", icon: "bi-list-check", label: "Subtask" },
  bug: { bg: "#e2483d", icon: "bi-bug-fill", label: "Bug" },
};

const PRIORITY_META: Record<PriorityLevel, { color: string; icon: string; label: string }> = {
  highest: { color: "#ae2a19", icon: "bi-chevron-double-up", label: "Highest" },
  high: { color: "#c9611a", icon: "bi-chevron-up", label: "High" },
  medium: { color: "#946f00", icon: "bi-dash-lg", label: "Medium" },
  low: { color: "#2f8132", icon: "bi-chevron-down", label: "Low" },
  lowest: { color: "#1558bc", icon: "bi-chevron-double-down", label: "Lowest" },
};

export const issueTypeMeta = (type: string) => TYPE_META[type as IssueType] ?? TYPE_META.task;
export const priorityMeta = (priority: string) => PRIORITY_META[priority as PriorityLevel] ?? PRIORITY_META.medium;

export function IssueTypeIcon({ title, type }: { title?: string; type: string }) {
  const meta = issueTypeMeta(type);
  return (
    <span aria-hidden="true" className="type-icon" style={{ background: meta.bg }} title={title ?? meta.label}>
      <i className={`bi ${meta.icon}`} />
    </span>
  );
}

export function PriorityIcon({ priority }: { priority: string }) {
  const meta = priorityMeta(priority);
  return (
    <i
      aria-hidden="true"
      className={`priority-icon bi ${meta.icon}`}
      style={{ color: meta.color }}
      title={`${meta.label} priority`}
    />
  );
}
